var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOff = function SvgOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 2v10.083h1.82V2h-1.82Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.689 4.954.772-.48L7.5 2.93l-.772.48A9.994 9.994 0 0 0 2 11.91c0 5.522 4.477 10 10 10s10-4.478 10-10a9.994 9.994 0 0 0-4.729-8.5l-.772-.48-.96 1.544.772.48a8.182 8.182 0 1 1-8.623 0Z",
    fill: "currentColor"
  })));
};
export { SvgOff as ReactComponent };
export default __webpack_public_path__ + "49090562b4a4908386ddada8f30a2941.svg";